import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LeftPanel, MainContainer, RightPanel } from "../login/LoginLayout";
import { StackPanelLogo } from "../login/StackCarePanelLogo";
import { ReducerStates } from "../../helpers/constants";
import AccountManagementHeader from "../login/AccountManagementHeader";
import LeftPanelFooter from "../login/LeftPanelFooter";
import ViewSubscriptionForm from "./ViewSubscriptionForm";
import { IAppState } from "../../helpers";
import { RedirectErrors } from "../../services/constants";
import { useAppSelector } from "../app/appHooks";
import { DateTimeISO, DateTimeNow } from "../../helpers/datetime";
import { clearSession } from "./dashboardSlice";
import SubscriptionManagementOptions from "./SubscriptionManagementOptions";
import SignOut from "./SignOut";

export default function ViewSubscriptions() {
  /* ---- Hooks ---- */
  const dispatch = useDispatch();

  const dashboardError = useSelector(
    (state: IAppState) => state.dashboardState.errorCode
  );
  const dashboardState = useSelector(
    (state: IAppState) => state.dashboardState.state
  );
  const token = useAppSelector((state) => state.appState.tokenObj);

  useEffect(() => {
    let isExpired = false;
    if (token && token.access_expiration) {
      const now = DateTimeNow();
      const expiration = DateTimeISO(token.access_expiration);
      isExpired = now > expiration;
    }
    if (isExpired) {
      dispatch(clearSession());
    }
  });

  useEffect(() => {
    if (dashboardState === ReducerStates.FAILED) {
      Object.keys(RedirectErrors).forEach((key) => {
        if (
          RedirectErrors[key as keyof typeof RedirectErrors] === dashboardError
        ) {
          dispatch(clearSession());
        }
      });
    }
  });

  return (
    <MainContainer>
      <LeftPanel>
        <StackPanelLogo />
        <AccountManagementHeader />
        <SubscriptionManagementOptions />
        <SignOut />
        <LeftPanelFooter />
      </LeftPanel>
      <RightPanel>
        <ViewSubscriptionForm />
      </RightPanel>
    </MainContainer>
  );
}
